import { Checkbox, Spacer } from '@odekoteam/doppio';
import { ThemeUICSSObject } from 'theme-ui';

const TIME_ID = 'mark-route-for-provider-pickup-time';
const ASAP_ID = 'mark-route-for-provider-asap';
const HINT_ID = 'mark-route-for-provider-pickup-hint';

const hintTextSx = {
  variant: 'text.paragraphSmDefault',
  color: 'secondaryText',
  display: 'block',
  marginTop: '4px',
};

// Doppio has no time control, so the native input takes the values of doppio's
// TextInput under the astronaut theme: 40px tall, 8px radius, 16px inset, 14px
// text, and its disabled colours, so the field reads disabled under ASAP.
const timeInputSx: ThemeUICSSObject = {
  display: 'block',
  boxSizing: 'border-box',
  height: '40px',
  paddingX: '16px',
  border: '1px solid',
  borderColor: 'backgroundMedium',
  borderRadius: 2,
  backgroundColor: 'white',
  color: 'text',
  fontFamily: 'body',
  fontSize: 1,
  ':disabled': {
    backgroundColor: 'secondaryBackgroundDisabled',
    borderColor: 'secondaryBackgroundDisabled',
    color: 'secondaryBackgroundActive',
    cursor: 'not-allowed',
  },
};

type PickupTimeFieldsProps = {
  time: string;
  asap: boolean;
  // Why the action is disabled: no time entered and ASAP not chosen.
  needsTime: boolean;
  onTimeChange: (time: string) => void;
  onAsapChange: (asap: boolean) => void;
};

// The courier pickup on the route's night, as HH:MM in the warehouse's zone,
// or ASAP. Controlled: the dialog owns the values for sending and for Change.
export function PickupTimeFields({
  time,
  asap,
  needsTime,
  onTimeChange,
  onAsapChange,
}: PickupTimeFieldsProps): JSX.Element {
  return (
    <>
      <label
        htmlFor={TIME_ID}
        sx={{ variant: 'text.paragraphMdDefault', fontWeight: 'bold' }}
      >
        Pickup time
      </label>
      <input
        id={TIME_ID}
        type="time"
        sx={timeInputSx}
        value={time}
        disabled={asap}
        aria-describedby={needsTime ? HINT_ID : undefined}
        onChange={(event): void => onTimeChange(event.target.value)}
      />
      {needsTime && (
        <span id={HINT_ID} sx={hintTextSx}>
          Enter a pickup time, or send ASAP.
        </span>
      )}
      <Spacer height="$2" />
      <Checkbox id={ASAP_ID} isChecked={asap} onChange={onAsapChange}>
        Send ASAP instead
      </Checkbox>
    </>
  );
}
